<template>
	<el-card>
		<div slot="header" class="header">
			<img src="../image/schedule.png" style="margin-left:2px">
			<span><strong>Face Sheet</strong></span>
		</div>

		<div v-if="loading" class="loading">
			<Loading :text="'Generating ' + patientCount + ' face sheets'"></Loading>
			<p style="padding-top:30px;">
				Documents will start downloading to your computer when complete.<br>
				Please don't navigate away from this page.
			</p>
		</div>
		<div class="loading complete" v-else>
			<p>Documents have been generated and are now downloading to your computer.</p>
		</div>

		<iframe @load="loaded" sandbox="allow-downloads-without-user-activation allow-top-navigation allow-same-origin" :src="src"></iframe>
	</el-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import Loading from '@/module/component/Loading.vue'
import OverviewCard from '..'

export default {
	name: 'population-facesheet-card',
	extends: OverviewCard,

	props: {
		print: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			loading: true
		}
	},

	computed: {
		...mapState(['baseUrl']),
		patientCount() {
			return Object.keys(this.print).length
		},
		src() {
			return this.baseUrl + '/document/facesheet/?id=' + Object.keys(this.print).join(',')
		}
	},

	methods: {
		loaded() {
			this.loading = false
		}
	},

	components: {
		Loading
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.loading {
	padding: 50px 0;

	p {
		text-align: center;
	}
}
iframe {
	display: none;
	width: 100%;
}
</style>
